import { render, staticRenderFns } from "./NLData.vue?vue&type=template&id=16e27e6e"
import script from "./NLData.vue?vue&type=script&lang=js"
export * from "./NLData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports